module.exports = __webpack_public_path__ + "img/plin-lg.ece5628d.png";